// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1IidZ","legacyBtn":"MutateMid_legacyBtn__31Lwk"};